import IconButton from '@mui/material/IconButton';
import CollapseClose from 'src/assets/icons/Generator/Actions/CollapseClose';
import CollapseOpen from 'src/assets/icons/Generator/Actions/CollapseOpen';

const CollapsibleButton = ({
  open,
  onClick,
}: {
  open: boolean;
  onClick?: () => void;
}) => {
  return (
    <IconButton
      size="small"
      onClick={onClick}
      aria-label={open ? 'Collapse' : 'Expand'}>
      {open ? (
        <CollapseClose style={{ padding: '2px' }} />
      ) : (
        <CollapseOpen style={{ padding: '2px' }} />
      )}
    </IconButton>
  );
};
export default CollapsibleButton;